import Cookies from 'js-cookie'
import i18n from '@/i18n'

const user = {
  state: {
    deviceInfo: null,
    memberInfo: null,
    token: null,
    language: Cookies.get('language') || 'zh',
    supportLanguages: [],
    goldInfo: null,
    vipInfo: null,
    inviteCode: null,
    unreadLetter: false,
    newLetter: false,
    lastChatMessage: { uuid: 0, read: false },
    gameBalanceInfo: {} // 遊戲錢包餘額
  },
  mutations: {
    SET_DEVICE_INFO: (state, data) => {
      state.deviceInfo = data
    },
    SET_MEMBER_INFO: (state, data) => {
      state.memberInfo = data
    },
    SET_TOKEN: (state, data) => {
      state.token = data
    },
    SET_LANGUAGE: (state, language) => {
      if (language !== 'undefined') {
        state.language = language
        Cookies.set('language', language)
        i18n.locale = language
      }
    },
    SET_SUPPORT_LANGUAGES: (state, supportLanguages) => {
      state.supportLanguages = supportLanguages
      Cookies.set('supportLanguages', supportLanguages)
    },
    SET_GOLD_INFO: (state, data) => {
      state.goldInfo = data
    },
    SET_VIP_INFO: (state, data) => {
      state.vipInfo = data
    },
    SET_INVITE_CODE: (state, data) => {
      state.inviteCode = data
    },
    SET_UNREAD_LETTER: (state, data) => {
      state.unreadLetter = data
    },
    SET_GAME_BALANCE_INFO: (state, data) => {
      state.gameBalanceInfo = data
    },
    SET_UNREAD_LETTER_PLUS: (state) => {
      if (!state.unreadLetter) {
        state.unreadLetter = 1
      } else {
        state.unreadLetter += 1
      }
    },
    SET_NEW_LETTER: (state, data) => {
      state.newLetter = data
    },
    SET_LAST_CHAT_MESSAGE: (state, data) => {
      state.lastChatMessage = data
    }
  },
  actions: {
    // 登入
    SetUserData({ commit }, data) {
      return new Promise((resolve, reject) => {
        commit('SET_MEMBER_INFO', data.member_info)
        commit('SET_GOLD_INFO', data.gold_info)
        commit('SET_VIP_INFO', data.vip_info)

        if (data.device_info !== undefined) {
          commit('SET_DEVICE_INFO', data.device_info)
        }
        if (data.token !== undefined) {
          commit('SET_TOKEN', data.token.token)
        }

        if (data.unread_letter_num === 0) {
          commit('SET_UNREAD_LETTER', false)
        } else {
          commit('SET_UNREAD_LETTER', data.unread_letter_num)
        }

        resolve()
      })
    },
    // 登出
    LogOut({ commit, state }) {
      return new Promise((resolve, reject) => {
        commit('SET_DEVICE_INFO', null)
        commit('SET_MEMBER_INFO', null)
        commit('SET_TOKEN', null)
        commit('SET_GOLD_INFO', null)
        commit('SET_VIP_INFO', null)
        commit('SET_GAME_BALANCE_INFO', [])
        localStorage.clear()
        resolve()
      })
    },
    setLanguage({ commit }, language) {
      commit('SET_LANGUAGE', language)
    }
  }
}

export default user
